<template>
  <Background v-if="perangkapMinyak && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/FOGT.png"
        alt="FOGT"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2>PERANGKAP LEMAK, MINYAK, GRIS (FOGT)</h2>
      <div class="fogt">
        <div class="fogt-container">
          <h3>BILANGAN PREMIS MAKANAN YANG MEMPUNYAI PERANGKAP MINYAK</h3>
          <img
            src="@/assets/fogt/makanan.png"
            alt="First Image"
          >
          <div class="text-overlay-center">
            <div class="text-center">
              <p><span class="text">PBT</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_premis_makanan_pbt) }}</span></p>
            </div>
            <div class="text-center swasta-text">
              <p><span class="text">SWASTA</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_premis_makanan_swasta) }}</span></p>
            </div>
          </div>
        </div>

        <div class="fogt-container">
          <h3>BILANGAN PERANGKAP MINYAK JENIS INDIVIDU</h3>
          <img
            src="@/assets/fogt/individu.png"
            alt="Second Image"
          >
          <div class="text-overlay-center">
            <div class="text-center">
              <p><span class="text">PBT</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_individu_pbt) }}</span></p>
            </div>
            <div class="text-center swasta-text">
              <p><span class="text">SWASTA</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_individu_swasta) }}</span></p>
            </div>
          </div>
        </div>

        <div class="fogt-container">
          <h3>BILANGAN PERANGKAP MINYAK JENIS KOMUNAL</h3>
          <img
            src="@/assets/fogt/komunal.png"
            alt="Third Image"
          >
          <div class="text-overlay-center">
            <div class="text-center">
              <p><span class="text">PBT</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_komunal_pbt) }}</span></p>
            </div>
            <div class="text-center swasta-text">
              <p><span class="text">SWASTA</span><br><span class="value number">{{ numberWithCommas(perangkapMinyak.bilangan_perangkap_minyak_komunal_swasta) }}</span></p>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()

const perangkapMinyak = ref({
  perangkapMinyak: {
    // eslint-disable-next-line camelcase
    bilangan_premis_makanan_pbt: 0,
    // eslint-disable-next-line camelcase
    bilangan_premis_makanan_swasta: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_individu_pbt: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_individu_swasta: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_komunal_pbt: 0,
    // eslint-disable-next-line camelcase
    bilangan_perangkap_minyak_komunal_swasta: 0,
  },

})

const responseData = ref(null)


async function  loadDataFromApi(){
  try {
    const response = await httpGet('kejuruteraan-kesihatan-umum/perangkap-minyak')


    responseData.value = response
    perangkapMinyak.value = response.data.perangkap_minyak.data

   
    perangkapMinyak.value.perangkapMinyak = {
      // eslint-disable-next-line camelcase
      bilangan_premis_makanan_pbt: perangkapMinyak.value ? perangkapMinyak.value.bilangan_premis_makanan_pbt : 0,
      // eslint-disable-next-line camelcase
      bilangan_premis_makanan_swasta: perangkapMinyak.value ? perangkapMinyak.value.bilangan_premis_makanan_swasta : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_individu_pbt: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_individu_pbt : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_individu_swasta: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_individu_swasta : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_komunal_pbt: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_komunal_pbt : 0,
      // eslint-disable-next-line camelcase
      bilangan_perangkap_minyak_komunal_swasta: perangkapMinyak.value ? perangkapMinyak.value.bilangan_perangkap_minyak_komunal_swasta : 0,
    }


  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  } 
}



onMounted(() => {
  loadDataFromApi()
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%;
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px;
  text-align: left;
  width: 100%;
}

h3 {
  color: rgb(21,0,105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
}

.fogt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;
}

.fogt-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
}

.text-overlay-center {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 60%;
  width: 100%;
  transform: translateY(-50%);
  padding: 0 20px;
  text-align: center;
}

.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.text-center p {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin: 0;
  color: #150069;
}

.number {
  color: #a80000;
  font-size: 28px;
  margin-top: 5px;
}

.swasta-text {
  margin-left: 400px;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
    max-width: 100%;
  }

  .pbt-image, .line-under-image {
    width: 70%;
  }

  h2, h3 {
    font-size: 1.2rem;
  }
  
  .text-overlay-center {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 80px;
  }

  .text-center p, .number {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2, h3 {
    font-size: 1rem;
  }

  .text-center p, .number {
    font-size: 1rem;
  }
}
</style>
